import { queryParams, searchPage } from '@/shared/constants/constants';
import { stripMarketPathPrefix } from '@/shared/utils/urls';

export const buildNativeSearchUrl = (
  term: string,
  view?: string,
  extraParams: Record<string, string> = {}
): string => {
  const root = window.Shopify?.routes?.root ?? '/';
  const params = new URLSearchParams({ [queryParams.SEARCH_QUERY]: term });

  if (view) {
    params.set(queryParams.SEARCH_VIEW, view);
  }

  Object.entries(extraParams).forEach(([key, value]) => params.set(key, value));

  return `${root}${searchPage.PATH_SEGMENT}?${params.toString()}`;
};

export const isSearchPage = (): boolean =>
  stripMarketPathPrefix(window.location.pathname).replace(/\/$/, '') ===
  `/${searchPage.PATH_SEGMENT}`;

export const isNativeSearchView = (): boolean =>
  new URLSearchParams(window.location.search).get(queryParams.SEARCH_VIEW) ===
  searchPage.NATIVE_VIEW;
